import React from "react";
import { Busy } from "../presentational/busy";
import { SelectedCharities } from "../presentational/selectedCharities";
import { Card } from "../presentational/card";
import { SuggestedCharity } from "../presentational/suggestedCharity";
import ReactGA from "react-ga";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/pro-light-svg-icons/faSearch";
import styles from "../../styles/panels/categorySelector.css";
import * as utilities from "../../middleware/utilities";

export class CategorySelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    ReactGA.pageview("/Spend/CategorySelector");
    utilities
      .isCodeValid(this.props.code)
      .then((valid) => {
        if (!valid) {
          this.props.onCodeError();
        }
      })
      .catch(() => {
        this.props.onCodeError();
      });
  }
  renderNavigation() {
    return (
      <div className={styles.navigation}>
        <div className={styles.message}>
          {this.props.dictionary.category_selector_header}
        </div>
      </div>
    );
  }
  renderCategories() {
    return (
      <div className={styles.categories}>
        {this.props.categories.map((category) => {
          return (
            <div
              className={styles.category}
              key={category.id}
              onClick={() => {
                ReactGA.event({
                  category: "User Action",
                  action: "Clicked Category " + category.title,
                  label: "/Spend/CategorySelector",
                });
                this.props.onSelectCategory(category);
              }}
            >
              <img
                src={category.thumbnail}
                title={category.title}
                className={styles.image}
              />
              <div className={styles.label}>{category.title}</div>
            </div>
          );
        })}
        <div
          className={styles.search}
          onClick={() => {
            ReactGA.event({
              category: "User Action",
              action: "Clicked Search All",
              label: "/Spend/CategorySelector",
            });
            this.props.onSearchAll();
          }}
        >
          <FontAwesomeIcon className={styles.icon} icon={faSearch} />
          <div className={styles.label}>
            {this.props.dictionary.category_selector_search_all}
          </div>
        </div>
      </div>
    );
  }
  renderAside() {
    return (
      <div className={styles.aside}>
        <SelectedCharities
          selectedCharities={this.props.selectedCharities}
          dictionary={this.props.dictionary}
          additionalCharityCount={this.props.additionalCharityCount}
          collapse={this.props.collapseSelectedCharities}
          donation={this.props.donation}
          onToggleCollapse={() => {
            this.props.onToggleCollapseSelectedCharities();
          }}
          onRemoveCharity={(ein) => {
            this.props.onRemoveCharity(ein);
          }}
          onContinue={() => {
            this.props.onContinue();
          }}
        />
        <Card
          src={this.props.donation.image}
          alt={this.props.donation.amount}
        />
        {this.props.donation.campaignDetail &&
        this.props.donation.campaignDetail.suggestedCharity &&
        this.props.donation.campaignDetail.suggestedCharityMarkup ? (
          <div className={styles.mobileHide}>
            <SuggestedCharity
              fixedPosition={true}
              charity={this.props.donation.campaignDetail.suggestedCharity}
              markup={this.props.donation.campaignDetail.suggestedCharityMarkup}
              selectedCharities={this.props.selectedCharities}
              dictionary={this.props.dictionary}
              additionalCharityCount={this.props.additionalCharityCount}
              onViewCharity={(charity) => {
                this.props.onViewCharity(charity);
              }}
              onSelectCharity={(charity) => {
                this.props.onSelectCharity(charity);
              }}
              onRemoveCharity={(ein) => {
                this.props.onRemoveCharity(ein);
              }}
            />
          </div>
        ) : null}
      </div>
    );
  }
  render() {
    if (this.props.busy) {
      return <Busy />;
    } else {
      return (
        <div className={styles.main}>
          {this.renderNavigation()}
          <div className={styles.content}>
            {this.renderCategories()}
            {this.props.donation.campaignDetail &&
            this.props.donation.campaignDetail.suggestedCharity &&
            this.props.donation.campaignDetail.suggestedCharityMarkup ? (
              <div className={styles.desktopHide}>
                <SuggestedCharity
                  fixedPosition={false}
                  charity={this.props.donation.campaignDetail.suggestedCharity}
                  markup={
                    this.props.donation.campaignDetail.suggestedCharityMarkup
                  }
                  selectedCharities={this.props.selectedCharities}
                  dictionary={this.props.dictionary}
                  additionalCharityCount={this.props.additionalCharityCount}
                  onViewCharity={(charity) => {
                    this.props.onViewCharity(charity);
                  }}
                  onSelectCharity={(charity) => {
                    this.props.onSelectCharity(charity);
                  }}
                  onRemoveCharity={(ein) => {
                    this.props.onRemoveCharity(ein);
                  }}
                />
              </div>
            ) : null}
          </div>
          {this.renderAside()}
        </div>
      );
    }
  }
}
